import { render } from "./CustomMaterialTextarea.vue?vue&type=template&id=02ead978"
import script from "./CustomMaterialTextarea.vue?vue&type=script&lang=js"
export * from "./CustomMaterialTextarea.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__